import { parse } from "postcode";
export const validatePostalCode = (value, country, required = true) => {
    if (!value.trim())
        return required ? "Postal code is required" : undefined;
    if (country === "GB" && !parse(value).valid) {
        return "Enter a valid UK postcode";
    }
    return undefined;
};
//# sourceMappingURL=validatePostalCode.js.map